import { signalStore } from '@ngrx/signals';
import { withDialogEffects } from './features/with-dialog-effects.feature';

// used for the withDialogEffects feature
export const DialogLocalStore = signalStore(withDialogEffects());
